export default __webpack_public_path__ + "static/media/sun-gray.5d821918.png";